<template>
	<div class="container-fluid">
	  <div class="header-container">
		<img src="../assets/icon_logo.png" class="logo-img" />
		<div class="nav-wrap desktop-nav">
		  <a href="#" :class="active == 'first' ?'aTitle aActive':'aTitle'" @click.prevent="changeA('first')">首页</a>
		  <a href="#" :class="active == 'bus' ? 'aTitle aActive':'aTitle'" @click.prevent="changeA('bus')">业务合作</a>
		  <a href="#" :class="active == 'news' || active == 'detail' ? 'aTitle aActive':'aTitle'" @click.prevent="changeA('news')">新闻中心</a>
		  <a href="#" :class="active == 'price'?'aTitle aActive':'aTitle'" @click.prevent="changeA('price')">价格介绍</a>
		  <a href="#" :class="active == 'us'?'aTitle aActive':'aTitle'" @click.prevent="changeA('us')">关于我们</a>
		  <div @click="goTo('https://store.laborhub.cn/#/register')" class="try" >免费试用</div>
		  <a href="#" class="aTitle" style="color: #006DF3;" @click="goTo('https://store.laborhub.cn/#/login')">登录</a>
		</div>
		<div class="mobile-menu-btn" @click.prevent="toggleMobileMenu">
		  <span></span>
		  <span></span>
		  <span></span>
		</div>
	  </div>
	  <transition name="slide">
		<div class="mobile-menu" v-if="showMobileMenu">
		  <a href="#" :class="active == 'first'?'mobile-nav-item active':'mobile-nav-item'" @click.prevent="changeA('first')">首页</a>
		  <a href="#" :class="active == 'bus' ?'mobile-nav-item active':'mobile-nav-item'" @click.prevent="changeA('bus')">业务合作</a>
		  <a href="#" :class="active == 'news' || active =='detail' ?'mobile-nav-item active':'mobile-nav-item'" @click.prevent="changeA('news')">新闻中心</a>
		  <a href="#" :class="active == 'price'?'mobile-nav-item active':'mobile-nav-item'" @click.prevent="changeA('price')">价格介绍</a>
		  <a href="#" :class="active == 'us'?'mobile-nav-item active':'mobile-nav-item'" @click.prevent="changeA('us')">关于我们</a>
		  <div @click="goTo('https://store.laborhub.cn/#/register')" class="mobile-try" >免费试用</div>
		  <div class="mobile-nav-item" style="color: #006DF3;" @click="goTo('https://store.laborhub.cn/#/login')">登录</div>
		</div>
	  </transition>
	  <div class="top_first" v-if="active == 'first'">
			<div class="top_first-title">
				全流程人力资源管理系统
			</div>
			<div class="top_first-subtitle">
				提供专业的全流程解决方案，助力企业高效用工、优化管理
			</div>
			<div class="top_first-desc">
				成为国内领先的用工管理平台，让企业和求职者之间的连接更加高效与可信
			</div>
			<div @click="showPops" class="bannerBtn">
				<span class="bannerBtn-text">联系我们</span>
				<img src="../assets/icon_jiantou.png" class="bannerBtn-icon"/>
			</div>
		</div>
		<div class="top_second" v-else-if="active == 'bus'">
			<div class="top_first-title">
				携手合作，推动行业创新，共创互利共赢的美好未来
			</div>
			<div class="top_first-subtitle">
				提供专业的全流程解决方案，助力企业高效用工、优化管理
			</div>
			<div @click="showPops" class="bannerBtn" >
				<span class="bannerBtn-text">咨询客服</span>
				<img src="../assets/icon_jiantou.png" class="bannerBtn-icon"/>
			</div>
		</div>
		<div class="top_news" v-else-if="active == 'news'">
			<div class="top_first-title">
				新闻中心
			</div>
			<div class="top_first-subtitle">
				打造一站式灵活用工SaaS行业标杆，将用工管理转化为企业增长动能
			</div>
			<div @click="showPops" class="bannerBtn" >
				<span class="bannerBtn-text">咨询客服</span>
				<img src="../assets/icon_jiantou.png" class="bannerBtn-icon"/>
			</div>
		</div>
		<div class="top_third" v-else-if="active == 'us'">
			<div class="top_first-title">
				打造未来招聘新生态，成就企业卓越人才
			</div>
			<div class="top_first-subtitle">
				提供专业的全流程解决方案，助力企业高效用工、优化管理
			</div>
			<div @click="showPops" class="bannerBtn">
				<span class="bannerBtn-text">咨询客服</span>
				<img src="../assets/icon_jiantou.png" class="bannerBtn-icon"/>
			</div>
		</div>
	</div>
  </template>
  
  <script>
  export default {
	name: 'head',
	props: {
	  msg: String,
	  active: String,
	},
	data() {
	  return {
		tabs: '',
		showMobileMenu: false,
		mode:'list'
	  };
	},
	onShow(){
		if(localStorage.getItem('mode')){
			this.mode = localStorage.getItem('mode');
		}
	},
	methods: {
	  changeA(val) {
		this.$emit('active', val);
		this.showMobileMenu = false; // 关闭移动端菜单
	  },
	  goTo(url){
		window.location.href = url;
	  },
	  showPops() {
		this.$emit('pop', true);
		this.showMobileMenu = false;
	  },

	  toggleMobileMenu() {
		this.showMobileMenu = !this.showMobileMenu;
	  }
	}
  }
  </script>
  
  <style scoped>
  @import url("../css/bootstrap.min.css");
  .top_first{
		background-image: url('../assets/pic_banner.png');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		width: 100%;
		height: auto;
		padding: 140px 12.5%;
		text-align: left;
	}
	.top_second{
		background-image: url('../assets/pic_yewu_banner.png');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		width: 100%;
		height: auto;
		padding: 140px 12.5%;
		text-align: left;
	}
	.top_news{
		background-image: url('../assets/pic_xinwen.png');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		width: 100%;
		height: auto;
		padding: 140px 12.5%;
		text-align: left;
	}

	.top_third{
		background-image: url('../assets/pic_us.png');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		width: 100%;
		height: auto;
		padding: 140px 12.5%;
		text-align: left;
	}
	.top_first-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 45px;
  font-family: 'Source Han Sans', 'Source Han Sans', sans-serif;
  color: #222;
  margin-bottom: 20px;
}
.top_first-subtitle {
  font-size: 22px;
  color: #3D3D3D;
  font-weight: 500;
  line-height: 33px;
  margin-bottom: 18px;
}
.top_first-desc {
  font-size: 14px;
  color: #666666;
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 28px;
}
.bannerBtn {
  background: #006DF3;
  color: #fff;
  border-radius: 40px;
  padding: 0 24px;
  font-size: 18px;
  font-weight: 700;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: background 0.2s;
  position: relative;
  z-index: 10;
  margin-top: 20px;
}
.bannerBtn:hover {
  background: #0056cc;
}
.bannerBtn-text {
  display: inline-block;
  font-size: 18px;
  font-weight: 700;
}
.bannerBtn-icon {
  width: 26px;
  height: 26px;
  margin-left: 8px;
  transform: translateY(0px);
}

  .header-container {
	background: #FFFFFF;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 12.5%;
	position: relative;
	min-height: 70px;
  }
  .logo-img {
	height: 62px;
	width: auto;
	max-width: 200px;
	transition: all 0.3s;
  }
  .nav-wrap {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 100%;
  }
  .aTitle {
	text-align: center;
	text-decoration: none;
	padding: 0 20px;
	height: 80px;
	line-height: 80px;
	font-weight: 700;
	font-size: 14px;
	color: #333333;
	white-space: nowrap;
	transition: all 0.3s ease;
  }
  .aActive {
	background: #006DF3;
	color: #ffffff;
	border-radius: 4px;
  }
  .try {
	height: 40px;
	padding: 0 22px;
	background: #006DF3;
	color: #FFFFFF;
	border-radius: 80px;
	margin-left: 14px;
	font-size: 18px;
	font-weight: 700;
	line-height: 40px;
	cursor: pointer;
	white-space: nowrap;
	transition: all 0.3s ease;
  }
  .try:hover {
	transform: scale(1.05);
  }
  .mobile-menu-btn {
	display: none;
	flex-direction: column;
	cursor: pointer;
	padding: 10px;
	margin-left: 10px;
  }
  .mobile-menu-btn span {
	width: 28px;
	height: 3px;
	background: #333;
	margin: 4px 0;
	border-radius: 2px;
	transition: 0.3s;
  }
  .mobile-menu {
	display: none;
  }
  @keyframes slideDown {
	from { opacity: 0; transform: translateY(-10px);}
	to { opacity: 1; transform: translateY(0);}
  }
  .mobile-nav-item {
	display: block;
	padding: 15px 10px;
	text-decoration: none;
	color: #333333;
	border-bottom: 1px solid #eee;
	font-weight: 700;
	font-size: 16px;
	transition: all 0.3s ease;
  }
  .mobile-nav-item.active {
	background: #006DF3;
	color: #ffffff;
  }
  .mobile-try {
	padding: 15px 10px;
	background: #006DF3;
	color: #FFFFFF;
	font-size: 16px;
	font-weight: 700;
	text-align: center;
	cursor: pointer;
	border-radius: 0 0 8px 8px;
  }
  
  @media (max-width: 768px) {
	.top_first{
		background-image: url('../assets/pic_banner.png');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		width: 100%;
		max-height:480px;
		padding: 20px 12.5%;
		text-align: left;
	}
	.top_news{
		background-image: url('../assets/pic_xinwen.png');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		width: 100%;
		max-height: 480px;
		padding: 20px 12.5%;
		text-align: left;
	}
	.top_first-title{
		font-size: 16px;
		line-height: 24px;
		margin-bottom: 10px;
	}
	.top_first-subtitle{		
		font-size: 14px;
		line-height: 22px;
		margin-bottom: 10px;
	}
	.top_first-desc{
		font-size: 12px;
		line-height: 18px;
		margin-bottom: 10px;
	}
	.top_second{
		background-image: url('../assets/pic_yewu_banner.png');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		width: 100%;
		max-height: 480px;
		padding: 20px 12.5%;
		text-align: left;
	}
	.top_third{
		background-image: url('../assets/pic_us.png');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		width: 100%;
		max-height: 480px;
		padding: 20px 12.5%;
		text-align: left;
	}
	.bannerBtn{
		margin-top: 10px;
	}
	.header-container {
	  padding: 0 10px;
	  min-height: 56px;
	}
	.logo-img {
	  height: 40px;
	  max-width: 120px;
	}
	.desktop-nav {
	  display: none;
	}
	.mobile-menu-btn {
	  display: flex;
	}
	.mobile-menu {
	  display: block;
	  flex-direction: column;
	  position: fixed;
	  top: 56px;
	  right: 0;
	  left: auto;
	  width: 120px;
	  background: #fff;
	  border-top: 1px solid #eee;
	  box-shadow: -2px 0 10px rgba(0,0,0,0.08);
	  z-index: 2000;
	  border-radius: 0 0 0 8px;
	  animation: slideDown 0.3s ease;
	}
  }
  </style>